import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { PlayContainer } from '../../styles';

export const StoppageContainer = styled(PlayContainer)`
    background: ${({ theme }) => theme.Table.zebraStripe};
    flex-direction: column;

    svg {
        ${BaseStyle.Mixins.fontStyles.ui['32m']}
    }
`;

export const StoppageText = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14m']}
    color: ${({ theme }) => theme.Text.secondary};
    padding-bottom: 2px;
`;
